(function() {
	'use strict';

	// user selector dialog template
	var userSelectorTemplateUrl = require('../userSelectorDialog/userSelectorDialog.template');

	angular.module('smb-app')
		.directive('smbContentTypeConfigForm', ContentTypeConfigFormDirective)
		.controller('smbContentTypeConfigFormController', [
			'$scope',
			'$mdDialog',
			'pxProgressService',
			'smbIconDataStore',
			ContentTypeConfigFormController
		]);

	var templateUrl = require('./contentTypeConfigForm.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.smbContentTypeConfigForm
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * The configuration form for creating and editing content types
	 *
	 * @usage
	 *
	 * <smb-content-type-config-form />
	 */
	function ContentTypeConfigFormDirective() {
		return {
			restrict: 'E',
			controller: 'smbContentTypeConfigFormController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				contentType: '=',
				onChange: '&'
			}
		};
	}

	function ContentTypeConfigFormController($scope, $mdDialog, pxProgressService, smbIconDataStore) {
		var vm = this;
		vm.isLoading = false;

		vm.iconSearchText = '';
		vm.contentTypeIcon = null;

		vm.onNameChange = onNameChange;
		vm.setIcon = setIcon;

		var originalIconId = -1;
		// cache initial value of content type name so we can later see
		// if the value actually changed.
		var typeName = '';
		/*** Controller initialization ***/
		(function initContentTypeConfigFormController() {
			vm.isLoading = true;
			pxProgressService.visible = true;
			smbIconDataStore.loadIcons()
				.then(function() {
					$scope.$watch('vm.contentType', function() {
						if (vm.contentType) {
							vm.contentTypeIcon = smbIconDataStore.icons.find(function(i) {
								return i.IconUserFriendlyName === vm.contentType.IconName;
							});
							originalIconId = (vm.contentTypeIcon && vm.contentTypeIcon.IconId) || originalIconId;
							typeName = vm.contentType.FolderName;
						}
					});
				})
				.finally(function() {
					vm.isLoading = false;
					pxProgressService.visible = false;
				});
		}());

		var userSelectorTemplateUrl = require('../userSelectorDialog/userSelectorDialog.template');
		function setIcon(event) {
			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: smbIconDataStore.icons,
					multiSelect: false
				}
			})
			.then(function (icon) {
				if (icon.length === 1) {
					vm.contentTypeIcon = icon[0];
					vm.contentType.IconName = vm.contentTypeIcon.IconUserFriendlyName;
					vm.contentType.IconId = vm.contentTypeIcon.IconId;
					if (vm.contentTypeIcon.IconId !== originalIconId) {
						originalIconId = -1;
						emitChange();
					}
				}
			}, function () {
				//cancel
			});
		}

		function onNameChange() {
			if (vm.contentType.FolderName !== typeName) {
				emitChange();
			}
		}

		function emitChange() {
			vm.onChange({contentType: vm.contentType});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeConfigForm/contentTypeConfigForm.js
// module id = 67
// module chunks = 1